import { render, staticRenderFns } from "./OnlineLearning.vue?vue&type=template&id=062fb4e0&"
import script from "./OnlineLearning.vue?vue&type=script&lang=js&"
export * from "./OnlineLearning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports